var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56;
import { ENV_IOS, ENV_ANDROID } from '../const';
/**
 * @link https://shimo.im/sheets/qRYXrP6GQRTYjcDg/FpMYS 百词斩 JSAPI 列表
 */
export var apiConfig = {
  audioPlay: (_a = {}, _a[ENV_IOS] = '7.0.0', _a[ENV_ANDROID] = '7.0.0', _a),
  audioPause: (_b = {}, _b[ENV_IOS] = '7.0.0', _b[ENV_ANDROID] = '7.0.0', _b),
  audioResume: (_c = {}, _c[ENV_IOS] = '7.0.0', _c[ENV_ANDROID] = '7.0.0', _c),
  audioStop: (_d = {}, _d[ENV_IOS] = '7.0.0', _d[ENV_ANDROID] = '7.0.0', _d),
  audioSeek: (_e = {}, _e[ENV_IOS] = '7.0.0', _e[ENV_ANDROID] = '7.0.0', _e),
  back: (_f = {}, _f[ENV_IOS] = '7.1.12', _f[ENV_ANDROID] = '7.1.13', _f),
  buyGoldCoin: (_g = {}, _g[ENV_IOS] = '7.1.1', _g[ENV_ANDROID] = false, _g),
  buyVirtualProduct: (_h = {}, _h[ENV_IOS] = '7.0.6', _h[ENV_ANDROID] = false, _h),
  buyIAPProduct: (_j = {}, _j[ENV_IOS] = '7.1.4', _j[ENV_ANDROID] = '7.1.4', _j),
  changeTheme: (_k = {}, _k[ENV_IOS] = '7.0.0', _k[ENV_ANDROID] = '7.0.0', _k),
  channelShare: (_l = {}, _l[ENV_IOS] = '7.0.0', _l[ENV_ANDROID] = '7.0.0', _l),
  channelShareImage: (_m = {}, _m[ENV_IOS] = '7.1.10', _m[ENV_ANDROID] = '7.1.12', _m),
  channelShareText: (_o = {}, _o[ENV_IOS] = '7.2.4', _o[ENV_ANDROID] = '7.2.4', _o),
  channelShareMiniProgram: (_p = {}, _p[ENV_IOS] = '7.3.6', _p[ENV_ANDROID] = '7.3.6', _p),
  commitShare: (_q = {}, _q[ENV_IOS] = '7.0.0', _q[ENV_ANDROID] = '7.0.0', _q),
  copyToClipboard: (_r = {}, _r[ENV_IOS] = '7.0.0', _r[ENV_ANDROID] = '7.0.0', _r),
  customizeStatusBar: (_s = {}, _s[ENV_IOS] = '7.1.0', _s[ENV_ANDROID] = '7.1.0', _s),
  exit: (_t = {}, _t[ENV_IOS] = '7.0.0', _t[ENV_ANDROID] = '7.0.0', _t),
  getRecentLogInfo: (_u = {}, _u[ENV_IOS] = '7.0.0', _u[ENV_ANDROID] = '7.0.0', _u),
  getShareableChannels: (_v = {}, _v[ENV_IOS] = '7.0.0', _v[ENV_ANDROID] = '7.0.0', _v),
  getStatusBarHeight: (_w = {}, _w[ENV_IOS] = false, _w[ENV_ANDROID] = '7.1.0', _w),
  globalShare: (_x = {}, _x[ENV_IOS] = '7.0.0', _x[ENV_ANDROID] = '7.0.0', _x),
  globalShareImage: (_y = {}, _y[ENV_IOS] = '7.1.10', _y[ENV_ANDROID] = '7.1.12', _y),
  globalShareText: (_z = {}, _z[ENV_IOS] = '7.2.4', _z[ENV_ANDROID] = '7.2.4', _z),
  globalShareMiniProgram: (_0 = {}, _0[ENV_IOS] = '7.3.6', _0[ENV_ANDROID] = '7.3.6', _0),
  launchApp: (_1 = {}, _1[ENV_IOS] = false, _1[ENV_ANDROID] = '7.1.8', _1),
  launchMiniProgram: (_2 = {}, _2[ENV_IOS] = '7.1.6', _2[ENV_ANDROID] = '7.1.8', _2),
  navigatorTo: (_3 = {}, _3[ENV_IOS] = '7.0.8', _3[ENV_ANDROID] = '7.0.9', _3),
  navigateTo: (_4 = {}, _4[ENV_IOS] = '7.0.8', _4[ENV_ANDROID] = '7.0.9', _4),
  launchSystemBrowser: (_5 = {}, _5[ENV_IOS] = '7.1.5', _5[ENV_ANDROID] = '7.1.7', _5),
  navigatorToWithCallback: (_6 = {}, _6[ENV_IOS] = false, _6[ENV_ANDROID] = false, _6),
  onBack: (_7 = {}, _7[ENV_IOS] = '7.0.8', _7[ENV_ANDROID] = '7.0.9', _7),
  onClose: (_8 = {}, _8[ENV_IOS] = '7.0.8', _8[ENV_ANDROID] = '7.0.9', _8),
  setCustomNavBack: (_9 = {}, _9[ENV_IOS] = '7.0.8', _9[ENV_ANDROID] = '7.0.9', _9),
  setCustomNavClose: (_10 = {}, _10[ENV_IOS] = '7.0.8', _10[ENV_ANDROID] = '7.0.9', _10),
  setNavBackCallback: (_11 = {}, _11[ENV_IOS] = '7.0.8', _11[ENV_ANDROID] = '7.0.9', _11),
  setNavCloseCallback: (_12 = {}, _12[ENV_IOS] = '7.0.8', _12[ENV_ANDROID] = '7.0.9', _12),
  confirmNavBack: (_13 = {}, _13[ENV_IOS] = '7.0.8', _13[ENV_ANDROID] = '7.0.9', _13),
  confirmNavClose: (_14 = {}, _14[ENV_IOS] = '7.0.8', _14[ENV_ANDROID] = '7.0.9', _14),
  openFeedback: (_15 = {}, _15[ENV_IOS] = '7.0.0', _15[ENV_ANDROID] = '7.0.0', _15),
  openWebView: (_16 = {}, _16[ENV_IOS] = '7.0.0', _16[ENV_ANDROID] = '7.0.0', _16),
  pay: (_17 = {}, _17[ENV_IOS] = '7.0.0', _17[ENV_ANDROID] = '7.0.0', _17),
  requestPay: (_18 = {}, _18[ENV_IOS] = '7.0.0', _18[ENV_ANDROID] = '7.0.0', _18),
  preload: (_19 = {}, _19[ENV_IOS] = '7.0.0', _19[ENV_ANDROID] = '7.0.0', _19),
  startRecord: (_20 = {}, _20[ENV_IOS] = '7.0.0', _20[ENV_ANDROID] = '7.0.0', _20),
  stopRecord: (_21 = {}, _21[ENV_IOS] = '7.0.0', _21[ENV_ANDROID] = '7.0.0', _21),
  reportByNative: (_22 = {}, _22[ENV_IOS] = '7.1.1', _22[ENV_ANDROID] = '7.1.1', _22),
  requestDaka: (_23 = {}, _23[ENV_IOS] = '7.0.1', _23[ENV_ANDROID] = '7.0.1', _23),
  requestLearningInfo: (_24 = {}, _24[ENV_IOS] = '7.0.1', _24[ENV_ANDROID] = '7.0.1', _24),
  setCloseButtonVisibility: (_25 = {}, _25[ENV_IOS] = '7.0.6', _25[ENV_ANDROID] = '7.0.8', _25),
  setNavigatorTitle: (_26 = {}, _26[ENV_IOS] = '7.0.0', _26[ENV_ANDROID] = '7.0.0', _26),
  setDocumentTitle: (_27 = {}, _27[ENV_IOS] = '7.0.0', _27[ENV_ANDROID] = '7.0.0', _27.isNativeAPI = true, _27),
  setNeedInterceptMedia: (_28 = {}, _28[ENV_IOS] = '7.0.8', _28[ENV_ANDROID] = false, _28),
  setShareState: (_29 = {}, _29[ENV_IOS] = '7.0.0', _29[ENV_ANDROID] = '7.0.0', _29),
  showDialog: (_30 = {}, _30[ENV_IOS] = '7.0.0', _30[ENV_ANDROID] = '7.0.0', _30),
  uploadImage: (_31 = {}, _31[ENV_IOS] = false, _31[ENV_ANDROID] = {
    from: '7.0.0',
    to: '7.2.5'
  }, _31),
  uploadFile: (_32 = {}, _32[ENV_IOS] = false, _32[ENV_ANDROID] = {
    from: '7.0.0',
    to: '7.2.5'
  }, _32),
  uploadLearningRecord: (_33 = {}, _33[ENV_IOS] = '7.0.1', _33[ENV_ANDROID] = '7.0.1', _33),
  uploadLog: (_34 = {}, _34[ENV_IOS] = '7.0.0', _34[ENV_ANDROID] = '7.0.0', _34),
  whenGlobalShareClicked: (_35 = {}, _35[ENV_IOS] = '7.0.0', _35[ENV_ANDROID] = '7.0.0', _35),
  whenPageOnTop: (_36 = {}, _36[ENV_IOS] = '7.0.8', _36[ENV_ANDROID] = false, _36),
  // ---------- API 能力增强 - 新增 (2021.11.29) ----------
  saveToAlbum: (_37 = {}, _37[ENV_IOS] = '7.1.18', _37[ENV_ANDROID] = '7.1.19', _37),
  setBouncingScroll: (_38 = {}, _38[ENV_IOS] = '7.1.18', _38[ENV_ANDROID] = false, _38),
  interceptNavBack: (_39 = {}, _39[ENV_IOS] = '7.1.18', _39[ENV_ANDROID] = '7.1.19', _39),
  interceptNavClose: (_40 = {}, _40[ENV_IOS] = '7.1.18', _40[ENV_ANDROID] = '7.1.19', _40),
  showNavigationBar: (_41 = {}, _41[ENV_IOS] = '7.1.18', _41[ENV_ANDROID] = '7.1.19', _41),
  hideNavigationBar: (_42 = {}, _42[ENV_IOS] = '7.1.18', _42[ENV_ANDROID] = '7.1.19', _42),
  changeOrientation: (_43 = {}, _43[ENV_IOS] = '7.1.18', _43[ENV_ANDROID] = '7.1.19', _43),
  getPrivacyInfo: (_44 = {}, _44[ENV_IOS] = '7.1.18', _44[ENV_ANDROID] = '7.1.19', _44),
  showStatusBar: (_45 = {}, _45[ENV_IOS] = '7.1.18', _45[ENV_ANDROID] = '7.1.19', _45),
  hideStatusBar: (_46 = {}, _46[ENV_IOS] = '7.1.18', _46[ENV_ANDROID] = '7.1.19', _46),
  setSwipeLeftBack: (_47 = {}, _47[ENV_IOS] = '7.1.18', _47[ENV_ANDROID] = '7.1.19', _47),
  setTouchCallout: (_48 = {}, _48[ENV_IOS] = '7.1.18', _48[ENV_ANDROID] = '7.1.19', _48),
  openInWebView: (_49 = {}, _49[ENV_IOS] = '7.1.18', _49[ENV_ANDROID] = '7.1.19', _49),
  // ---------- API 能力增强 - 新增 (end) ----------
  // ---------- API 能力增强 - 新增 (2022.02.28) ----------
  setScreenOffTimeout: (_50 = {}, _50[ENV_IOS] = false, _50[ENV_ANDROID] = '7.1.22', _50),
  clearScreenOffTimeout: (_51 = {}, _51[ENV_IOS] = false, _51[ENV_ANDROID] = '7.1.22', _51),
  // ---------- API 能力增强 - 新增 (end) ----------
  // ---------- API 能力增强 - 新增 (2022.06.22) ----------
  getCanGoBack: (_52 = {}, _52[ENV_IOS] = '7.2.3', _52[ENV_ANDROID] = '7.2.3', _52),
  openAppSettings: (_53 = {}, _53[ENV_IOS] = '7.2.3', _53[ENV_ANDROID] = '7.2.3', _53),
  turnOnNotifPush: (_54 = {}, _54[ENV_IOS] = '7.2.3', _54[ENV_ANDROID] = '7.2.3', _54),
  // ---------- API 能力增强 - 新增 (end) ----------
  // ---------- API 能力增强 - 新增 (2022.06.22) ----------
  refreshBasicInfo: (_55 = {}, _55[ENV_IOS] = '7.2.9', _55[ENV_ANDROID] = '7.3.0', _55),
  // ---------- API 能力增强 - 新增 (end) ----------
  // ---------- API 能力增强 - 新增 (2022.12.27) ----------
  vibrate: (_56 = {}, _56[ENV_IOS] = '7.3.8', _56[ENV_ANDROID] = '7.3.8', _56)
  // ---------- API 能力增强 - 新增 (end) ----------
};